import styled from '@emotion/styled';
import { brandNeutralColors } from '@anyroad/theme';

export const TimerContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 16px 20px;
  background-color: ${brandNeutralColors.background.light};
  margin-bottom: 16px;
  color: ${brandNeutralColors.text.primary};
  font-family:
    'Proxima Nova',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 13px;
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    padding: 10px 12px;
    font-size: 12px;
    margin-bottom: 10px;
  }
`;

export const TimerText = styled.div`
  text-align: left;
  line-height: 18px;
`;

export const ModalHeader = styled.h1`
  margin-bottom: 32px;
`;

export const ModalMessage = styled.p`
  margin-bottom: 32px;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
